module.exports = __webpack_public_path__ + "static/media/before.8c63a15d.jpg";